import React, { Component } from "react";
import { Images } from "../../theme";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { useTranslation } from "react-i18next";
import "./styles.css";

export default () => {
  const responsive = {
    0: { items: 1 },
    568: { items: 2 },
    1024: { items: 3 },
  };
  const { t } = useTranslation();

  const items = [
    <div className="revire-card">
      <div className="d-flex align-items-center">
        <img className="profile_image" src={Images.profile_icon} alt="image" />
        <div className="px-4">
          <p className="text-blue  mb-0 text-20" style={{ fontWeight: 700 }}>
            Elina Doe
          </p>
          <p
            className="text-grey Opensans text-14"
            style={{ fontStyle: "italic" }}
          >
            {t("Happy_Client")}
          </p>
        </div>
      </div>
      <p
        className="text-grey Opensans mt-2 text-14"
        style={{ fontStyle: "italic" }}
      >
        {t("Happy_Client_Description")}
      </p>
    </div>,
    <div className="revire-card">
      <div className="d-flex align-items-center">
        <img className="profile_image" src={Images.profile_icon} alt="image" />
        <div className="px-4">
          <p className="text-blue  mb-0 text-20" style={{ fontWeight: 700 }}>
            {t("Elina_Doe")}
          </p>
          <p
            className="text-grey Opensans text-14"
            style={{ fontStyle: "italic" }}
          >
            {t("Happy_Client")}
          </p>
        </div>
      </div>
      <p
        className="text-grey Opensans mt-2 text-14"
        style={{ fontStyle: "italic" }}
      >
        {t("Happy_Client_Description")}
      </p>
    </div>,
    <div className="revire-card">
      <div className="d-flex align-items-center">
        <img className="profile_image" src={Images.profile_icon} alt="image" />
        <div className="px-4">
          <p className="text-blue  mb-0 text-20" style={{ fontWeight: 700 }}>
            {t("Elina_Doe")}
          </p>
          <p
            className="text-grey Opensans text-14"
            style={{ fontStyle: "italic" }}
          >
            {t("Happy_Client")}
          </p>
        </div>
      </div>
      <p
        className="text-grey Opensans mt-2 text-14"
        style={{ fontStyle: "italic" }}
      >
        {t("Happy_Client_Description")}
      </p>
    </div>,
    <div className="revire-card">
      <div className="d-flex align-items-center">
        <img className="profile_image" src={Images.profile_icon} alt="image" />
        <div className="px-4">
          <p className="text-blue  mb-0 text-20" style={{ fontWeight: 700 }}>
            {t("Elina_Doe")}
          </p>
          <p
            className="text-grey Opensans text-14"
            style={{ fontStyle: "italic" }}
          >
            {t("Happy_Client")}
          </p>
        </div>
      </div>
      <p
        className="text-grey Opensans mt-2 text-14"
        style={{ fontStyle: "italic" }}
      >
        {t("Happy_Client_Description")}
      </p>
    </div>,
    <div className="revire-card">
      <div className="d-flex align-items-center">
        <img className="profile_image" src={Images.profile_icon} alt="image" />
        <div className="px-4">
          <p className="text-blue  mb-0 text-20" style={{ fontWeight: 700 }}>
            {t("Elina_Doe")}
          </p>
          <p
            className="text-grey Opensans text-14"
            style={{ fontStyle: "italic" }}
          >
            {t("Happy_Client")}
          </p>
        </div>
      </div>
      <p
        className="text-grey Opensans mt-2 text-14"
        style={{ fontStyle: "italic" }}
      >
        {t("Happy_Client_Description")}
      </p>
    </div>,
    <div className="revire-card">
      <div className="d-flex align-items-center">
        <img className="profile_image" src={Images.profile_icon} alt="image" />
        <div className="px-4">
          <p className="text-blue  mb-0 text-20" style={{ fontWeight: 700 }}>
            {t("Elina_Doe")}
          </p>
          <p
            className="text-grey Opensans text-14"
            style={{ fontStyle: "italic" }}
          >
            {t("Happy_Client")}
          </p>
        </div>
      </div>
      <p
        className="text-grey Opensans mt-2 text-14"
        style={{ fontStyle: "italic" }}
      >
        {t("Happy_Client_Description")}
      </p>
    </div>,
    <div className="revire-card">
      <div className="d-flex align-items-center">
        <img className="profile_image" src={Images.profile_icon} alt="image" />
        <div className="px-4">
          <p className="text-blue  mb-0 text-20" style={{ fontWeight: 700 }}>
            {t("Elina_Doe")}
          </p>
          <p
            className="text-grey Opensans text-14"
            style={{ fontStyle: "italic" }}
          >
            {t("Happy_Client")}
          </p>
        </div>
      </div>
      <p
        className="text-grey Opensans mt-2 text-14"
        style={{ fontStyle: "italic" }}
      >
        {t("Happy_Client_Description")}
      </p>
    </div>,
  ];
  let arr = [{ name: "" }, { name: "" }, { name: "" }, { name: "" }];
  return (
    <div className="bg-light">
      <div className="container">
        <p className="text-dark m-0 MontserratSemiBold text-center pt-5 rent-head">
          {t("Rental_Reviews")}
        </p>
        <p className="Montserrat text-center pb-5 text-18 rent-subhead">
          {t("Rental_Reviews_Description")}
        </p>
      </div>
      {/* <div className="row px-4 pb-4">
        {arr.map((val) => {
          return (
            <div className="col-md-3 col-lg-3 ">
              <div className="revire-card">
                <div className="d-flex align-items-center">
                  <img
                    className="profile_image"
                    src={Images.profile_icon}
                    alt="image"
                  />
                  <div className="px-4">
                    <p
                      className="text-blue  mb-0 text-20"
                      style={{ fontWeight: 700 }}
                    >
                      Elina Doe
                    </p>
                    <p
                      className="text-grey Opensans text-14"
                      style={{ fontStyle: "italic" }}
                    >
                      Happy Client
                    </p>
                  </div>
                </div>
                <p
                  className="text-grey Opensans mt-2 text-14"
                  style={{ fontStyle: "italic" }}
                >
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium dolore laudantium totam rem aperiam, eaque ipsa
                  quae ab
                </p>
              </div>
            </div>
          );
        })}
      </div> */}
      <div className="row pb-5 pt-4">
        <div className="col-12">
          <AliceCarousel
            mouseTracking
            animationDuration={2000}
            autoPlay="true"
            items={items}
            autoPlayControls={false}
            responsive={responsive}
            controlsStrategy="alternate"
          />
        </div>
      </div>
    </div>
  );
};
